import logo from '../assets/logo.png';

export default function Logo({ size = 'default' }) {
  const iconSize = size === 'small' ? 'h-7' : 'h-9';
  const textSize = size === 'small' ? 'text-base' : 'text-xl';

  return (
    <div className="flex items-center gap-2">
      <img
        src={logo}
        alt="PixelUtility icon"
        className={`${iconSize} w-auto`}
      />
      <span className={`font-bold ${textSize} tracking-tight`}>
        <span className="text-gray-900">Pixel</span>
        <span className="text-indigo-500">Utility</span>
      </span>
    </div>
  );
}
